<form [formGroup]="displayForm" (ngSubmit)="onSubmit()" class="create-display-form">
    @if (isProcessing) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <div class="form-section">
        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Display Name</mat-label>
                <input matInput formControlName="deviceName" placeholder="e.g., Entry Display">
                <mat-icon matSuffix>tv</mat-icon>
                @if (displayForm.get('deviceName')?.hasError('required')) {
                <mat-error>Display name is required</mat-error>
                }
                @if (displayForm.get('deviceName')?.hasError('minlength')) {
                <mat-error>Display name must be at least 2 characters</mat-error>
                }
            </mat-form-field>
        </div>

        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Device Hardware ID</mat-label>
                <input matInput formControlName="deviceHardwareID" placeholder="Leave empty to auto-generate">
                <mat-icon matSuffix>memory</mat-icon>
                <mat-icon matPrefix class="generate-icon" (click)="generateGUID()" title="Generate new GUID"
                    style="cursor:pointer">
                    auto_awesome
                </mat-icon>
            </mat-form-field>
        </div>

        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>MAC Address</mat-label>
                <input matInput formControlName="macAddress" placeholder="e.g., AA:BB:CC:DD:EE:FF">
                <mat-icon matSuffix>router</mat-icon>
            </mat-form-field>
        </div>

        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Pi Device ID</mat-label>
                <input matInput formControlName="piDeviceId" placeholder="Optional Raspberry Pi device ID">
                <mat-icon matSuffix>developer_board</mat-icon>
            </mat-form-field>
        </div>

        <div class="form-row">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="deviceDescription" placeholder="Optional description"
                    rows="2"></textarea>
                <mat-icon matSuffix>note</mat-icon>
            </mat-form-field>
        </div>
    </div>

    <div class="form-actions">
        <button mat-raised-button color="accent" type="submit" [disabled]="displayForm.invalid || isProcessing">
            <mat-icon>save</mat-icon>
            {{ mode === 'edit' ? 'Update Display' : 'Create Display' }}
        </button>
        <button mat-button type="button" (click)="onCancel()" [disabled]="isProcessing">
            Cancel
        </button>
    </div>
</form>